import { CustomerActivityGraph } from "./ConsumerActivityGraph";

export default CustomerActivityGraph;
